export default __webpack_public_path__ + "static/media/pencil-bright-winter.ee921bc9.png";